import React, { useEffect, useState } from "react";
import { Button, Typography } from "@material-ui/core";
import AutorenewRoundedIcon from "@material-ui/icons/AutorenewRounded";
import { ReactRender } from "@/components/ReactRender";
import { useTranslation } from "@/langs/useTranslation";
import { getLastTaskInfo, getPrinterList, removePrinter } from "@/apis/apiCollection";
import DataTable from "@/components/DataTable";
import ChipStatus from "@/components/ChipStatus";
import { useHistory } from "react-router-dom";
import { detectPrinterApi, setUsbPortStatusApi } from "@/apis/usbConnectionsAPI";
import { Description } from "@material-ui/icons";
import modalConfirm from "../Modal/modalConfirm";
import { successHandling } from "@/helpers/successHandling";
import RefreshBtn from "@/components/commons/RefreshBtn";
import useStyles from "@/styles/deviceStyle";
import HasPermission from "../commons/HasPermission";

export const PrintInfoTable = React.forwardRef(
  (
    {
      className,
      style,
      footer,
      children,
      onLoaded,
      device_id
    },
    ref
  ) => {
    const { t } = useTranslation();

    const classes = useStyles();

    const [list, setList] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [refreshSetUp, setRefreshSetUp] = useState(false);
    const [disableDetectBtn, setDisableDetectBtn] = useState(false);
    const [clickAlready, setClickAlready] = useState(false);
    const [statusSet, setStatusSet] = useState({
      status: "empty",
      updated_at: ""
    });

    const getListWithoutTask = async () => {
      const data = await getPrinterList({ device_id });
      if (data && data.devicePrinters && data.devicePrinters.length > 0) {
        setList(data.devicePrinters);
      }
    }

    const getList = async noRefresh => {
      if (!noRefresh) {
        setList([]);
      }
      const data = await getLastTaskInfo({ deviceId: device_id, execute_type: "device_printers" })
      if (data && data.status) {
        if (data.status === "completed" || data.status === "failed") {
          setDisableDetectBtn(false);
          setRefresh(false);
        } else {
          setDisableDetectBtn(true);
        }
        setStatusSet({
          status: data.status ? data.status : "empty",
          updated_at: data.updated_at ? data.updated_at : ""
        });
      } else {
        setDisableDetectBtn(false);
      }
      if (data.status === "completed") {
        const listData = await getPrinterList({ device_id });
        if (listData && listData.devicePrinters && listData.devicePrinters.length > 0) {
          setList(listData.devicePrinters);
        }
      }
    };

    const columns = [
      {
        data: "description",
        title: t({ defaultMessage: "描述" }),
        searchable: false,
      },
      {
        data: "status",
        title: t({ defaultMessage: "状态" }),
        searchable: false,
        createdCell: (td, data, row) => {
          if (data === "connection") {
            ReactRender(<ChipStatus type="success" label={t({ defaultMessage: "已连接" })} />, td)
          } else {
            ReactRender(<ChipStatus type="error" label={t({ defaultMessage: "未连接" })} />, td)
          }
        }
      },
      {
        data: "vId",
        title: "VID",
        searchable: false,
      },
      {
        data: "pId",
        title: "PID",
        searchable: false,
      },
      {
        data: "usbPort",
        title: t({ defaultMessage: "USB端口" }),
        searchable: false,
      },
      {
        data: "errorLog",
        title: "Error Log",
        searchable: false,
      },
      {
        data: null,
        title: t({ defaultMessage: "操作" }),
        className: "center nowrap",
        searchable: false,
        orderable: false,
        width: 220,
        createdCell: (td, data, row) => {
          ReactRender(
            <>
              <HasPermission permission="device_detail_printer_information_reset">
                <Button
                  size="small"
                  color="primary"
                  onClick={e => {
                    modalConfirm({
                      title: t({ defaultMessage: "重置" }),
                      content: t(
                        {
                          defaultMessage:
                            "是否确认重置该打印机?"
                        },
                      ),
                      onConfirm: async () => {
                        await setUsbPortStatusApi(
                          device_id,
                          row.portId,
                          true,
                          t,
                          { defaultMessage: "重置成功" },
                          "reset_usb_port"
                        )
                        if (ref.current) ref.current.reload()
                      }
                    });
                  }}
                >
                  {t({ defaultMessage: "重置" })}
                </Button>
              </HasPermission>

              <Button
                size="small"
                color="secondary"
                onClick={e => {
                  modalConfirm({
                    title: t({ defaultMessage: "移除" }),
                    content: t(
                      {
                        defaultMessage:
                          "是否移除该打印机?"
                      },
                    ),
                    onConfirm: async () => {
                      await removePrinter({ deviceId: device_id, portId: row.portId })
                      successHandling(t, { defaultMessage: "移除成功" })
                      if (ref.current) ref.current.reload()
                    }
                  });
                }}
              >
                {t({ defaultMessage: "移除" })}
              </Button>
            </>,
            td
          );
        }
      }
    ];

    // const ajax = (data, callback) => {
    //   return getPrinterList({
    //     device_id
    //   }).then(res => {
    //     callback({
    //       data: res.devicePrinters,
    //       // draw: data.draw,
    //       // recordsFiltered: res.total,
    //       // recordsTotal: res.total
    //     });
    //   });
    // };

    useEffect(() => {
      getListWithoutTask();
    }, [])

    return (
      <>
        <div>
          <Typography variant="h5">
            {t({ defaultMessage: "打印信息" })}
            {/* <AutorenewRoundedIcon
              onClick={() => {
                if (printInfoTableRef.current) printInfoTableRef.current.reload()
              }}
              size="small"
              className={`${classes.listBtn} ${classes.reload_btn}`}
            /> */}
          </Typography>
          <div className={classes.usbDetectTextAndBtn}>
            <RefreshBtn
              getList={getList}
              detectApi={detectPrinterApi}
              statusSet={statusSet}
              open
              refresh={refresh}
              setRefresh={setRefresh}
              disableDetectBtn={disableDetectBtn}
              setDisableDetectBtn={setDisableDetectBtn}
              deviceId={device_id}
              setClickAlready={setClickAlready}
              clickAlready={clickAlready}
            />
          </div>
        </div>
        <DataTable
          ref={ref}
          ordering={false}
          columns={columns}
          data={list}
          // ajax={ajax}
          className={className}
          style={style}
          scrollable
          onLoaded={onLoaded}
          autoLoad
          showCheckAll={false}
          paging={false}
          options={{ serverSide: false, paging: false }}
        >
          {children}
        </DataTable>
      </>
    );
  }
);